import { Outlet } from 'react-router'
import { AuthWrapper } from '@/components/AuthWrapper'
import { UserpilotTracker } from '@/components/UserpilotTracker'

export function AuthLayout() {
    return (
        <AuthWrapper>
            <UserpilotTracker>
                <Outlet />
            </UserpilotTracker>
        </AuthWrapper>
    )
}
